/** Kind of generated output document; each has its own output settings. */
export const OutputDocumentType = {
  /** Purchase order PDF. */
  PURCHASE_ORDER: 'PURCHASE_ORDER'
} as const;

export type OutputDocumentType = (typeof OutputDocumentType)[keyof typeof OutputDocumentType];
